module.exports = __webpack_public_path__ + "img/img28.da2001f3.png";